module.exports = __webpack_public_path__ + "static/media/add-user.d74bcd7f.png";